
import { Routes, Route } from "react-router-dom";



import Dashboard from "../pages/Dashboard";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Terms from "../pages/Terms";


const AppRoutes = () => {
  return (
    <Routes>


      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/dashboard" element={<Dashboard />} />


    </Routes>
  );
};

export default AppRoutes;
